import { useAuthStore } from '@/stores/authStore'
import { useAdminViewStore } from '@/stores/adminViewStore'

/**
 * True when admin-only UI should render: the user is an admin AND they have not
 * hidden admin surfaces for a demo (see the toggle on /app/admin).
 *
 * Use this for every admin-gated *view* — the Admin nav tab, job-detail debug
 * images, the promote form. Do NOT use it to guard the /app/admin route itself:
 * that check stays on the raw role so the page is still reachable by typing the
 * URL while admin UI is hidden.
 */
export function useAdminUi(): boolean {
  const isAdmin = useAuthStore((s) => s.user?.role === 'admin')
  const showAdminUi = useAdminViewStore((s) => s.showAdminUi)
  return isAdmin && showAdminUi
}
